import React from 'react';
import { Redirect } from 'react-router';
import { PermissionSetType } from 'api/models';
import { RoutePaths } from 'constant';
import { useUserPermissionSetType } from 'hooks/permissions';
import { useBillingFeatureFlag, useIsAccountActive } from 'hooks/use-account';
import {
  PermissionRouteProps,
  SecureRoute,
} from './route-with-permission-check';

const whitelistedPaths = [
  RoutePaths.billingSettings,
  RoutePaths.teamMemberSettings,
];

const isWhitelistedPath = (pathname?: string) =>
  pathname && !!whitelistedPaths.includes(pathname);

export const AuthorisedRoute = (props: PermissionRouteProps) => {
  const { location } = props;
  const isAccActive = useIsAccountActive();
  const isBillingEnabled = useBillingFeatureFlag();
  const currentUserPermissionSetType = useUserPermissionSetType();

  const isAccountAdmin =
    currentUserPermissionSetType === PermissionSetType.AccountAdmin;

  if (!isBillingEnabled) {
    return <SecureRoute {...props} />;
  }

  return (
    <SecureRoute>
      {isAccActive || isWhitelistedPath(location?.pathname) ? (
        <SecureRoute {...props} />
      ) : (
        isAccountAdmin && <Redirect to={RoutePaths.billingSettings} />
      )}
    </SecureRoute>
  );
};
